import PropTypes from 'prop-types'
import classNames from 'classnames'

// styles
import style from '@aytm/app/stats/components/toggle-triplet/ToggleTriplet.module.scss'

// The two choices are otherwise indistinguishable in the DOM: they carry the same class and differ
// only in their label, so `name` is what lets a caller address one side rather than the copy on it.
const ToggleTriplet = ({ children, className, name, leftLabel, rightLabel, activeLeft, onLeftClick, onRightClick }) => {
  const testId = side => (name ? `stat-toggle-${name}-${side}` : undefined)

  return (
    <div className={classNames(style.triplet, className)} data-testid={name ? `stat-toggle-${name}` : undefined}>
      <span
        data-testid={testId('left')}
        data-side="left"
        data-active={activeLeft ? 'true' : 'false'}
        className={classNames(style['triplet-item'], style['triplet-item-left'], {
          [style['triplet-item-active']]: activeLeft
        })}
        onClick={onLeftClick}
      >
        {leftLabel}
      </span>

      <span
        data-testid={testId('center')}
        data-side="center"
        className={classNames(style['triplet-item'], style['triplet-item-center'], style['triplet-item-active'])}
      >
        {children}
      </span>

      <span
        data-testid={testId('right')}
        data-side="right"
        data-active={activeLeft ? 'false' : 'true'}
        className={classNames(style['triplet-item'], style['triplet-item-right'], {
          [style['triplet-item-active']]: !activeLeft
        })}
        onClick={onRightClick}
      >
        {rightLabel}
      </span>
    </div>
  )
}

ToggleTriplet.propTypes = {
  children: PropTypes.any,
  name: PropTypes.string,
  leftLabel: PropTypes.node,
  rightLabel: PropTypes.node,
  activeLeft: PropTypes.bool,
  onLeftClick: PropTypes.func,
  onRightClick: PropTypes.func,
  className: PropTypes.string
}

export default ToggleTriplet
